import { LogoLoader } from '@monocle-money/react-components';

export function Splash() {
  return (
    <div style={container}>
      <LogoLoader active={true} />
    </div>
  );
}

const container = {
  display: 'grid',
  placeItems: 'center',
  width: '100vw',
  height: '100vh',
};